// extracted by mini-css-extract-plugin
export default {"table":"Table_table__7wj0E","striped":"Table_striped__5bKk-","hoverable":"Table_hoverable__qGnyj","compact":"Table_compact__F0YCL"};